module.exports = "<div class=q-marg-all-xs-at-md>{%- firstname %}&nbsp;{%- lastname %}</div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/rma/html/customerNameTemplate.html
// module id = 1416
// module chunks = 1